import { EltType } from 'legacy/lut/classes/models/partner360/ELT/EltType'
import {
  ELT_FORM_SECTION,
  IRevenue,
  TComplexSectionData,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { isDocType } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/isDocType'
import { useMemo } from 'react'

import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'
import { useTableActions } from '../../../hooks/useTableActions'
import { TForceUpdateConfig } from '../../../models/TForceUpdateConfig'
import { RoundTableLabel } from '../../roundTable/components/roundTableLabel/RoundTableLabel'
import { RoundTableSection } from '../../roundTable/components/roundTableSection/RoundTableSection'
import { ForceUpdate } from '../../styledComponents/forceUpdate/ForceUpdate'
import { RevenueNote } from '../../styledComponents/notes/RevenueNote'
import { StyledTable } from '../../styledComponents/styledTable/StyledTable'
import { Title } from '../../styledComponents/title/Title'
import { changeGrandTotalBySubtotals } from '../helpers/changeGrandTotalBySubtotals'
import { getRevenueShortViewColumns } from '../helpers/getRevenueShortViewColumns'
import styles from '../Revenue.module.scss'

import { keyField, visibleKeys } from './configs'

interface IProps {
  fYear: number
  fQuarter: number
  revenue: IRevenue[]
  forceUpdate: (section: ELT_FORM_SECTION, config?: TForceUpdateConfig) => void
  updateFormData: (data: TComplexSectionData) => void
  netNdpValue: ActualsValueTypes
  eltType?: EltType
}

export const RevenueShortView = ({
  revenue,
  forceUpdate,
  updateFormData,
  fYear,
  fQuarter,
  netNdpValue,
  eltType = EltType.Pptx,
}: IProps) => {
  const revenueData = useMemo(() => revenue || [], [revenue])
  const { onChangeByKey } = useTableActions<IRevenue>({
    updateFormData: updateFormData,
    data: revenueData,
    changeComputedFieldsFn: changeGrandTotalBySubtotals,
  })

  const columns = useMemo(
    () =>
      getRevenueShortViewColumns({
        netNdpValue,
        onChange: onChangeByKey(keyField),
        currentYear: fYear,
        currentQuarter: fQuarter,
        onlyCurrentAndPrevYear: isDocType(eltType),
      }),
    [onChangeByKey, fYear, fQuarter, netNdpValue, eltType]
  )
  const items = useMemo(() => {
    const filtered = revenueData.filter((el) => visibleKeys.includes(el.Key))
    const sorted = filtered.sort((a, b) => {
      return visibleKeys.indexOf(a.Key) - visibleKeys.indexOf(b.Key)
    })
    return sorted
  }, [revenueData])

  return (
    <RoundTableSection>
      <Title
        noteContent={RevenueNote}
        variant="withBackground"
        text={getFormedEltTranslation('section-financial-snapshot')}
        translationReplaceParams={[
          {
            key: '{netNdp}',
            value: netNdpValue.toUpperCase(),
          },
        ]}
        rightContent={
          <>
            <RoundTableLabel />
            <ForceUpdate isIcon onClick={forceUpdate} section={ELT_FORM_SECTION.REVENUE} />
          </>
        }
      />

      <StyledTable<IRevenue>
        columns={columns}
        items={items}
        keyField={keyField}
        classes={{ td: styles.shortTdWidth }}
      />
      {/*<RevenueTypeSelectDialog*/}
      {/*  forceUpdateData={forceUpdateData}*/}
      {/*  onRevenueTypeClick={(revenueType, revenueDesc) => {*/}
      {/*    forceUpdate(ELT_FORM_SECTION.REVENUE, { revenue: revenueType })*/}
      {/*    onChangePrimitiveFormData('RevenueDesc')(revenueDesc)*/}
      {/*    onChangePrimitiveFormData: setShowDialog(false)*/}
      {/*  }}*/}
      {/*  closeDialog={() => {*/}
      {/*    setShowDialog(false)*/}
      {/*  }}*/}
      {/*  show={showDialog}*/}
      {/*/>*/}
    </RoundTableSection>
  )
}
